<input *ngIf="!isShowText" type="text" [maxlength]="maxLength" class="w-100pc border bg-white rounded  text-renderer"
    [(ngModel)]="value" (input)="onInput($event)" [placeholder]="placeHolder"
    [ngClass]="{'border-danger': isRequired && showValidator, 'disabled bg-light-grey': this.disabled }" tabindex="0">


<span *ngIf="isShowText"> {{ value }}</span>